import {
  TooltipConfig,
  TooltipConfigWithTranslation,
  useTooltipStore,
} from '@/store/tooltipStore';

export function showTooltip(
  config: TooltipConfigWithTranslation | TooltipConfig
) {
  const { show } = useTooltipStore.getState();

  show(config);

  return;
}
